import React, { useCallback, useEffect } from "react";
import { pure } from "recompose";
import styles from "./RedirectLoadingScreen.scss";
import { Loader } from "~/components";
import { defineMessages, injectIntl } from "react-intl";
import styled from "styled-components";

export const msgs = defineMessages({
  sorry: {
    id: "redirect_loading_screen.message.sorry",
    description: "Displayed when redirecting to no availability",
    defaultMessage: "We're sorry!",
  },
  fullyBooked: {
    id: "redirect_loading_screen.message.fully_booked",
    description: "Displayed when redirecting to no availability",
    defaultMessage: "We are fully booked for your dates..",
  },
  searching: {
    id: "redirect_loading_screen.message.searching",
    description: "Displayed when redirecting to no availability",
    defaultMessage: "Don't worry, we'll show you more options in the city.",
  },
  cancelRedirection: {
    id: "redirect_loading_screen.message.cancel",
    description: "Cancel redirect",
    defaultMessage: "Cancel redirect",
  },
});

const CancelMessage = styled.div`
  margin-top: 30px;
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
`;

function RedirectLoadingScreen({ intl: { formatMessage }, onClickCancel }) {
  const cancelWithEscKey = useCallback(e => {
    const escKey = 27;
    if (e.keyCode === escKey) {
      onClickCancel();
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", cancelWithEscKey, false);

    return () => {
      document.removeEventListener("keydown", cancelWithEscKey, false);
    };
  }, [cancelWithEscKey]);

  return (
    <div className={styles.container}>
      <div>
        <h1>{formatMessage(msgs.sorry)}</h1>
      </div>

      <div className={styles.loaderContainer}>
        <Loader />
      </div>
      <div>{formatMessage(msgs.fullyBooked)}</div>
      <CancelMessage onClick={onClickCancel}>{formatMessage(msgs.cancelRedirection)}</CancelMessage>
    </div>
  );
}

RedirectLoadingScreen.propTypes = {};

export default injectIntl(pure(RedirectLoadingScreen));
